import { Info } from 'lucide-react';
import React from 'react';

interface ImageRequirementsProps {
    aspectRatio: string;
    minimumSize: string;
}

export const ImageRequirements = ({
    aspectRatio,
    minimumSize
}: ImageRequirementsProps) => (
    <div className="rounded-md border bg-accent/50 p-3 text-xs">
        <div className="mb-1 flex items-center gap-1 font-medium">
            <Info className="size-4 text-primary" />
            Image Requirements
        </div>
        <p>• Aspect ratio: {aspectRatio}</p>
        <p>• Format: JPG, PNG, or WebP</p>
        <p>• Recommended minimum: {minimumSize}</p>
    </div>
);
